<template class="full-height">
  <div class="full-height promotional-plan-data">
    <!-- 活動管理 -->
    <el-dialog
      append-to-body
      :title="formatDialogTitle"
      :visible.sync="dialogFormVisible"
      width="60%"
      @closed="handleDialogClose"
    >
      <el-form
        ref="promotionalPlanFormRef"
        :model="promotionalPlanForm"
        @submit.native.prevent
        label-width="80px"
        label-position="right"
        :rules="rules"
      >
        <el-form-item prop="name" label="方案名稱">
          <el-input v-model="promotionalPlanForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="initBalance" label="可用金額">
          <el-input v-model="promotionalPlanForm.initBalance"></el-input>
        </el-form-item>
        <el-form-item prop="initHeadCount" label="可用人數">
          <el-input v-model="promotionalPlanForm.initHeadCount"></el-input>
        </el-form-item>
        <el-form-item prop="date" label="日期">
          <el-date-picker
            v-model="promotionalPlanForm.date"
            type="daterange"
            align="right"
            unlink-panels
            @input="handleChangeDate"
            range-separator="至"
            start-placeholder="開始日期"
            end-placeholder="結束日期"
            value-format="yyyy-MM-dd"
            class="w-full-picker"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="priority" label="排序">
          <el-input-number
            v-model="promotionalPlanForm.priority"
            :min="isAddMode ? 0 : 1"
            :max="total"
          ></el-input-number>
          <!-- <el-select v-model="promotionalPlanForm.priority">
            <el-option :value="0" :label="0" v-show="isAddMode">
            </el-option>
            <el-option v-for="sort in total" :key="`sort${sort}`" :label="sort" :value="sort">
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item prop="status" label="狀態">
          <el-switch v-model="promotionalPlanForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveData" type="warning" style="color: #4b4b4b">儲 存</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-form :inline="true" class="filter-form" @submit.native.prevent>
      <el-form-item label="查詢">
        <el-input
          v-model="listQuery.qry"
          placeholder="輸入方案名稱"
          @keyup.enter.native="getList"
        />
      </el-form-item>

      <el-button
        type="primary"
        @click="getList"
        icon="el-icon-search"
        circle
        style="margin-top: 8px; margin-left: 5px"
        :disabled="listLoading"
      ></el-button>
      <el-button
        type="warning"
        @click="addData"
        circle
        icon="el-icon-plus"
        :disabled="listLoading"
      ></el-button>
      <el-button
        style="cursor: pointer"
        type="success"
        :loading="listLoading"
        circle
        icon="el-icon-refresh-left"
        @click="refresh()"
      ></el-button>
    </el-form>

    <div style="position: relative; height: 80%">
      <el-table
        ref="formDetailsTable"
        v-loading="listLoading"
        :data="list"
        size="mini"
        border
        fit
        style="width: 100%"
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="方案名稱" width="200">
          <template slot-scope="{ row }">
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="使用期間" width="200">
          <template slot-scope="{ row }">
            <span v-show="!!row.startDate || row.endDate"
              >{{ row.startDate }} 至 {{ row.endDate }}</span
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="排序" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.priority }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="啟用狀態" width="80">
          <template slot-scope="scope">
            <el-popconfirm
              title="確定要變更啟用狀態嗎？"
              @confirm="handleCheckStatus(scope.row)"
              cancel-button-text="取消"
              confirm-button-text="確定"
            >
              <el-switch slot="reference" @click.native.prevent="" :value="scope.row.status">
              </el-switch>
            </el-popconfirm>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button type="success" @click="editData(scope.row)" size="mini"> 編輯 </el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" label="刪除" width="120">
          <template slot-scope="scope">
            <el-button type="danger" @click="deleteData(scope.row)" size="mini"> 刪除 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import checkPermission from '@/utils/permission' // 权限判断函数
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { Message } from 'element-ui'
import {
  getPromotionalPlans,
  patchPromotionalPlan,
  deletePromotionalPlan,
} from '@/api/promotionalPlan'
import { deepClone } from '@/utils'
import TravelerData from '@/views/ita/components/travelerViewData.vue'

const validateOnlyInputNumber = (rule, value, callback) => {
  if (!value) {
    callback()
  }
  let data = new RegExp(/^\d+$/)
  if (!data.test(value)) {
    callback(new Error('限輸入數字'))
  } else {
    callback()
  }
}
export default {
  name: 'promotionalPlanTable',
  components: { Pagination, TravelerData },
  data() {
    return {
      dialogFormVisible: false,
      listLoading: false,
      formLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
      },
      total: 0,
      list: [],
      promotionalPlanForm: {
        id: null,
        name: null,
        initHeadCount: null,
        initBalance: null,
        date: null,
        startDate: null,
        endDate: null,
        priority: 0,
        status: true,
      },
      rules: {
        name: [{ required: true, message: '請輸入方案名稱', trigger: 'blur' }],
        priority: [{ required: true, message: '請輸入排序', trigger: 'blur' }],
        initHeadCount: [{ required: false, validator: validateOnlyInputNumber, trigger: 'blur' }],
        initBalance: [{ required: false, validator: validateOnlyInputNumber, trigger: 'blur' }],
      },
    }
  },
  async created() {
    await this.getList()
  },

  computed: {
    isAddMode() {
      return !this.promotionalPlanForm.id
    },
    formatDialogTitle() {
      const isAddMode = !this.promotionalPlanForm.id
      const format = isAddMode ? '新增' : '編輯'
      return `${format}活動管理`
    },
  },
  methods: {
    checkPermission,
    async refresh() {
      this.defaultListQuerySetting()
      await this.getList()
    },
    handleDialogClose() {
      this.$nextTick(() => {
        this.$refs.promotionalPlanFormRef.clearValidate()
        this.$refs.promotionalPlanFormRef.resetFields()
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleCheckStatus(row) {
      let vm = this
      const payload = {
        id: row.id,
        name: row.name,
        initHeadCount: row.initHeadCount,
        initBalance: row.initBalance,
        startDate: row.startDate,
        endDate: row.endDate,
        priority: row.priority,
        status: !row.status,
      }
      vm.listLoading = true
      patchPromotionalPlan(payload)
        .then(async res => {
          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
          await vm.getList()
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          vm.listLoading = false
        })
    },

    defaultListQuerySetting() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
      }
    },
    defaultFormData() {
      this.promotionalPlanForm = {
        id: null,
        name: null,
        initHeadCount: null,
        initBalance: null,
        date: null,
        startDate: null,
        endDate: null,
        priority: 0,
        status: true,
      }
    },
    async getList() {
      this.listLoading = true
      getPromotionalPlans(this.listQuery)
        .then(response => {
          this.list = response.data.data
          this.total = response.data.total
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    async saveData() {
      let vm = this
      if (vm.promotionalPlanForm.date && vm.promotionalPlanForm.date.length > 1) {
        vm.promotionalPlanForm.startDate = vm.promotionalPlanForm.date[0]
        vm.promotionalPlanForm.endDate = vm.promotionalPlanForm.date[1]
      }
      let payload = {
        id: vm.promotionalPlanForm.id,
        name: vm.promotionalPlanForm.name,
        initHeadCount: vm.promotionalPlanForm.initHeadCount,
        initBalance: vm.promotionalPlanForm.initBalance,
        startDate: vm.promotionalPlanForm.startDate,
        endDate: vm.promotionalPlanForm.endDate,
        priority: vm.promotionalPlanForm.priority,
        status: vm.promotionalPlanForm.status,
      }
      console.log(payload)
      this.$refs.promotionalPlanFormRef.validate(valid => {
        if (!valid) return
        vm.listLoading = true
        patchPromotionalPlan(payload)
          .then(async res => {
            Message({
              message: '資料處理完成',
              type: 'success',
              duration: 5 * 1000,
            })
            vm.dialogFormVisible = false
            await vm.getList()
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            vm.listLoading = false
          })
      })
    },
    editData(row) {
      this.promotionalPlanForm = deepClone(row)
      if (!this.promotionalPlanForm.startDate || !this.promotionalPlanForm.endDate) {
        this.promotionalPlanForm.date = []
      } else {
        this.promotionalPlanForm.date = [
          this.promotionalPlanForm.startDate,
          this.promotionalPlanForm.endDate,
        ]
      }
      this.dialogFormVisible = true
    },
    async deleteData(row) {
      let vm = this
      if (confirm(`確定刪除【${row.name}】方案?`)) {
        vm.listLoading = true
        deletePromotionalPlan({ id: row.id })
          .then(async res => {
            await vm.getList()
            vm.$message({
              message: '操作成功',
              type: 'success',
            })
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            vm.listLoading = false
          })
      }
    },
    addData() {
      this.defaultFormData()
      this.dialogFormVisible = true
    },
    handleChangeDate() {
      this.$forceUpdate()
    },
  },
}
</script>

<style scoped>
.full-height {
  position: relative;
  height: 100%;
}

.w-full-picker {
  width: 100%;
}
</style>
